import { render, staticRenderFns } from "./planRulesTable.vue?vue&type=template&id=67f66175"
import script from "./planRulesTable.vue?vue&type=script&lang=js"
export * from "./planRulesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports